export default __webpack_public_path__ + "static/media/avatar_alison1.9a34a8d7.mp3";